import React from 'react';
import {observer} from 'mobx-react';
import s from '../../s';
import DescMainContent from './desc-main-content';

type Props = {
    toggleExpandable: (e: React.KeyboardEvent<HTMLDivElement>, id: string) => void;
};

const DescMain: React.FC<Props> = observer(({toggleExpandable}) => {
    if (!s.ready) {
        return null;
    }

    return (
        <div id="prod-desc">
            <div
                id="prod-main-desc"
                className="prod-sub-header toggle-bs"
                role="button"
                data-bs-toggle="collapse"
                data-bs-target="#prod-main-desc-inner"
                aria-expanded={false}
                aria-controls="prod-main-desc-inner"
                tabIndex={0}
                onKeyDown={e => toggleExpandable(e, 'prod-main-desc')}
            >
                Description
            </div>
            <div
                style={{height: 'auto', maxHeight: 'inherit'}}
                id="prod-main-desc-inner"
                className="collapse show"
            >
                {<DescMainContent />}
            </div>
        </div>
    );
});

export default DescMain;
